module.exports = __webpack_public_path__ + "img/71b9603983a6435c280a2d336391ed2a.71b96039.png";